import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'sia-grid-base',
  templateUrl: './sia-base.component.html',
  styleUrls: ['./sia-base.component.scss'],
  standalone: true,
})
export class SiaBaseComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {}

  constructor() {}

  ngOnInit(): void {}

  destroyDxComponent(dxComponent: any, clientId: string) {
    if (dxComponent && dxComponent.instance) {
      dxComponent.instance.dispose();
      dxComponent = null;
      var doc = document.getElementById(clientId);
      if (doc) doc.remove();
    }
  }
}
